<template lang="pug">
  .main-slider
    .main-slider__btn.main-slider__btn_prev
      button.main-slider-button(
        @click="onArrowLeft()"
      )
    .main-slider__btn.main-slider__btn_next
      button.main-slider-button(
        @click="onArrowRight()"
      )
    .main-slider__body(
      v-touch:swipe.left="swipeHandlerLeft"
      v-touch:swipe.right="swipeHandlerRight"
    )
      .obj-list.obj-list_camps(
        v-if="slides.length >= slideShow"
        ref="campsSlider"
        :style="sliderStyle"
      )
        .obj-list__item(
          v-for="camp in slides"
          :style="{ transition: 'all 0.5s'}"
        )
          .obj.obj_horizontal
            .obj__media
              image-slider(
              :data-images="camp.sliderImages"
              :active-slide="camp.slide"
              @onslider="onSaveSlide"
              :element-id="camp.id"
              )
            router-link.obj__body(
              :to="`/pages/camps/${camp.id}`"
            )
              .obj__name(
              ) {{camp.name}}
              .obj__title {{camp.description}}
              <!--.obj__rating-->
                <!--rating(-->
                <!--:value="camp.rating"-->
                <!--)-->
              .obj__description {{camp.address.region}}, {{camp.address.area}}
              <!--.obj__date Сезон: {{ shiftSeasons[camp.season] }}-->
    .main-slider__dots
      .main-slider-dots
        .main-slider-dots__item.main-slider-dot(
          v-for="(camp, $index) in campsData"
          :class="{ 'main-slider-dot_active': $index + 1 === currentSlide }"
        )

</template>

<script>
import ImageSlider from "@/components/imageSlider/ImageSlider.vue";
import Rating from "@/components/rating/Rating.vue";

export default {
  name: "CampsSlider",
  components: {
    ImageSlider,
    Rating
  },
  props: {
    sliderData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      campsData: [],
      slides: [],
      // slide: 1,
      activeToTransform: true,
      currentSlide: 1,
      slideShow: 2,
      sliderTranslate: 0
    };
  },
  computed: {
    shiftSeasons() {
      return this.$store.getters.shiftSeasons();
    },
    slideCount() {
      return this.slides.length;
    },
    sliderDefaultTranslate() {
      return this.rounding((100 / this.slideCount * this.slideShow * -1), 4);
    },
    sliderStyle() {
      return {
        width: (100 / this.slideShow) * this.slideCount + "%",
        transform: "translate(" + this.sliderDefaultTranslate + "%)"
      };
    }
  },
  methods: {
    swipeHandlerLeft() {
      this.onArrowRight();
    },
    swipeHandlerRight() {
      this.onArrowLeft();
    },
    onSaveSlide(id, slide) {
      this.campsData = this.campsData.map(el => {
        if (el.id === id) {
          el.slide = slide - 1;
        }
        return el;
      });
    },
    rounding(num) {
      //округление до 4 цифр после запятой
      return Number(num.toFixed(4));
    },
    onArrowLeft() {
      this.currentSlide - 1 < 1 ? (this.currentSlide = this.campsData.length) : (this.currentSlide -= 1);
      if (!this.activeToTransform) {
        return;
      }
      //Логика слайдера
      const campsSlider = this.$refs.campsSlider;
      campsSlider.style.transition = "all 0.5s";
      this.sliderTranslate += this.rounding((100 / this.slideCount));
      this.sliderTranslate = this.rounding(this.sliderTranslate);
      this.$refs.campsSlider.style.transform =
        "translate(" + this.sliderTranslate + "%)";
      this.activeToTransform = false;

      setTimeout(() => {
        if (Math.ceil(this.sliderTranslate) >= 0) {
          this.$refs.campsSlider.style.transition = "none";
          const translate = 0 - this.rounding((100 / this.slideCount * (this.slideCount - (this.slideShow * 2))));
          this.$refs.campsSlider.style.transform =
            "translate(" + translate + "%)";
          this.sliderTranslate = translate;
        }
        this.activeToTransform = true;
      }, 500);
    },
    onArrowRight() {
      this.currentSlide + 1 > this.campsData.length ? (this.currentSlide = 1) : (this.currentSlide += 1);
      if (!this.activeToTransform) {
        return;
      }
      //Логика слайдера
      const campsSlider = this.$refs.campsSlider;
      campsSlider.style.transition = "transform 0.5s";
      this.sliderTranslate -= this.rounding((100 / this.slideCount));
      this.sliderTranslate = this.rounding(this.sliderTranslate);
      this.$refs.campsSlider.style.transform =
        "translate(" + this.sliderTranslate + "%)";
      this.activeToTransform = false;

      setTimeout(() => {
        if (Math.floor(this.sliderTranslate - 100 / this.slideCount * this.slideShow) <= -100) {
          this.$refs.campsSlider.style.transition = "none";
          this.$refs.campsSlider.style.transform =
            "translate(" + this.sliderDefaultTranslate + "%)";
          this.sliderTranslate = this.sliderDefaultTranslate;
        }
        this.activeToTransform = true;
      }, 500);
    },
    createSliderData(data) {
      data = JSON.parse(JSON.stringify(data));
      this.campsData = data.map(camp => {
        camp.slide = 0;
        camp.sliderImages = camp.photos
          .map(photo => photo.preview_376x340)
          .slice(0, 5);
        return camp;
      });
      const cloneAfter = [];
      const cloneBefore = [];
      for (var i = 0; i < this.slideShow; i++) {
        cloneAfter.push(this.campsData[i]);
        cloneBefore.unshift(this.campsData[this.campsData.length - 1 - i]);
      }
      this.slides = cloneBefore.concat(this.campsData, cloneAfter);
      this.sliderTranslate = this.sliderDefaultTranslate;
    },
    calcSlideShow() {
      if (window.innerWidth <= 720 && this.slideShow !== 1) {
        this.slideShow = 1;
      } else if (window.innerWidth > 720 && this.slideShow !== 2) {
        this.slideShow = 2;
      }
    }
  },
  mounted() {
    if (this.sliderData.length > 0) {
      this.createSliderData(this.sliderData);
    }

    var _self = this;
    _self.calcSlideShow();
    window.addEventListener("resize", function() {
      _self.calcSlideShow();
      if (_self.sliderData.length > 0) {
        _self.createSliderData(_self.sliderData);
      }
    });
  },
  watch: {
    sliderData(sliderData) {
      if (sliderData.length > 0) {
        this.createSliderData(sliderData);
      }
    }
  }
};
</script>
